import React from 'react';
import { GraduationCap, ExternalLink, Clock, BookOpen, Monitor, AlertCircle } from 'lucide-react';

const CE_INFO = [
    { profession: '치과의사', color: '#2563eb', hours: '연간 8시간 (8평점)', required: '의료윤리·의료법령 2시간 필수', online: '온라인 연간 최대 2평점', note: '학술대회 참석 시 1회 4평점 인정 (연 1회)', url: 'https://edu.kda.or.kr/', siteName: '대한치과의사협회 보수교육센터' },
    { profession: '치과위생사', color: '#059669', hours: '연간 8시간 (8평점)', required: '직업윤리·의료법령 2시간 필수', online: '온라인 교육 가능', note: '치위생교육원에서 온·오프라인 교육 신청', url: 'https://edu.kdha.or.kr/', siteName: '치위생교육원' },
    { profession: '치과기공사', color: '#7c3aed', hours: '연간 8시간 (8평점)', required: '의료윤리·관계법령 포함', online: '온라인 교육 가능', note: '대한치과기공사협회에서 교육 신청', url: 'https://www.kdtech.or.kr/edu/test04.asp', siteName: '대한치과기공사협회 보수교육' },
];

const CE_SITES = [
    { name: '치과의사 보수교육센터', url: 'https://edu.kda.or.kr/', desc: '대한치과의사협회 보수교육 신청·이수현황' },
    { name: '치위생교육원', url: 'https://edu.kdha.or.kr/', desc: '치과위생사 온·오프라인 보수교육 신청' },
    { name: '치과기공사 보수교육', url: 'https://www.kdtech.or.kr/edu/test04.asp', desc: '대한치과기공사협회 보수교육 안내·신청' },
];

function CEEducation() {
    return (
        <div style={{ maxWidth: 800, margin: '0 auto', padding: 24 }}>
            <h1 style={{ display: 'flex', alignItems: 'center', gap: 12, fontSize: 24, fontWeight: 700, margin: '0 0 8px' }}>
                <GraduationCap size={28} color="#6366f1" /> 보수교육
            </h1>
            <p style={{ color: '#6b7280', margin: '0 0 24px', fontSize: 14 }}>치과 의료인 보수교육 안내 및 신청 사이트</p>

            <div style={{ background: '#eef2ff', border: '1px solid #c7d2fe', borderRadius: 12, padding: 16, marginBottom: 24, display: 'flex', gap: 10, alignItems: 'flex-start' }}>
                <AlertCircle size={20} color="#6366f1" style={{ flexShrink: 0, marginTop: 2 }} />
                <div style={{ fontSize: 13, color: '#4338ca', lineHeight: 1.6 }}>
                    <strong>보수교육 안내</strong><br />
                    모든 치과 의료인은 면허 신고 시 연간 8시간(8평점) 이상의 보수교육을 이수해야 합니다.
                </div>
            </div>

            <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 16 }}>직종별 교육 요건</h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16, marginBottom: 32 }}>
                {CE_INFO.map(info => (
                    <div key={info.profession} style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, padding: 20, borderLeft: `4px solid ${info.color}` }}>
                        <h3 style={{ margin: '0 0 12px', fontSize: 16, fontWeight: 600, color: info.color }}>{info.profession}</h3>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                            <Row icon={<Clock size={16} />} label="이수시간" value={info.hours} />
                            <Row icon={<BookOpen size={16} />} label="필수과목" value={info.required} />
                            <Row icon={<Monitor size={16} />} label="온라인" value={info.online} />
                            <Row icon={<AlertCircle size={16} />} label="참고" value={info.note} />
                        </div>
                        <a href={info.url} target="_blank" rel="noopener noreferrer"
                            style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginTop: 12, padding: '8px 14px', background: info.color + '10', color: info.color, borderRadius: 8, textDecoration: 'none', fontSize: 13, fontWeight: 500 }}>
                            {info.siteName} <ExternalLink size={12} />
                        </a>
                    </div>
                ))}
            </div>

            <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 16 }}>신청 사이트</h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                {CE_SITES.map(s => (
                    <a key={s.url} href={s.url} target="_blank" rel="noopener noreferrer"
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: 16, background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, textDecoration: 'none', color: '#1f2937' }}>
                        <div>
                            <h3 style={{ margin: '0 0 4px', fontSize: 15, fontWeight: 600 }}>{s.name}</h3>
                            <p style={{ margin: 0, fontSize: 13, color: '#6b7280' }}>{s.desc}</p>
                        </div>
                        <ExternalLink size={18} color="#6366f1" />
                    </a>
                ))}
            </div>
        </div>
    );
}

function Row({ icon, label, value }) {
    return (
        <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: 13 }}>
            <span style={{ color: '#9ca3af', flexShrink: 0, marginTop: 1 }}>{icon}</span>
            <span style={{ color: '#6b7280', width: 60, flexShrink: 0 }}>{label}</span>
            <span style={{ color: '#1f2937' }}>{value}</span>
        </div>
    );
}

export default CEEducation;
